'use client';

import React, { useMemo } from 'react';
import { LoopFetchProductResult } from '@ts/loopFetchProductResult';
import useVariant from '@utils/hooks/product/useVariant';
import dynamic from 'next/dynamic';
import ProductCartSkeleton from './ProductCartSkeleton';
import { useQuery } from '@tanstack/react-query';
import { Product } from '@ts/product';
import { getStockWatchAction } from '@app/actions/cart/actions';
import { isProductOversellable } from '../Stock/Stock.utils';

/**
 * Hydration errors occur here since text content is adhjusted during render
 */
const ProductCart = dynamic(() => import('./ProductCart'), {
  ssr: false,
  loading: () => <ProductCartSkeleton />,
});

type ProductPropertiesProps = {
  data: LoopFetchProductResult;
  dictionary: Record<string, string>;
};
export default function ProductPayment({
  dictionary,
  data,
}: ProductPropertiesProps) {
  const [quantity, setQuantity] = React.useState(1);

  const { data: stockWatch } = useQuery({
    queryKey: ['stockWatch', data.product.id],
    queryFn: () =>
      getStockWatchAction({
        items: data.variants.map((variant) => ({
          partNo: variant.id,
          quantity: 1000,
        })),
      }),
    enabled: !isProductOversellable(data.product),
  });

  const variant = useVariant(data);
  const selectedVariant = useMemo(() => {
    if (data.product.hasVariants) {
      return variant;
    }

    return data.currentVariant;
  }, [variant, data.currentVariant, data.product.hasVariants]);

  return (
    <div className="mb-3 mt-3 grid grid-cols-12 gap-y-3">
      <ProductCart
        stockWatch={stockWatch}
        className="col-span-full"
        setQuantity={setQuantity}
        quantity={quantity}
        dictionary={dictionary}
        variant={selectedVariant}
      />
    </div>
  );
}
